import XIcon from "@uui/XClose";

import { IconButton, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import {
  getPaymentMethodDescription,
  isCard,
} from "@app/analytics/account/Billing/utils";
import type { PaymentMethod } from "@app/common/types";

import Chip from "@rui/Chip";
import Stack, { Row } from "@rui/Stack";

interface CardItemProps {
  paymentMethod: PaymentMethod;
  onRemove?: () => void;
}

const CloseButton = ({
  sm = false,
  onClick,
}: {
  sm?: boolean;
  onClick?: () => void;
}) => {
  if (!onClick) return null;
  return (
    <Row
      showAbove={sm ? undefined : "sm"}
      showBelow={sm ? "sm" : undefined}
      height="fit-content"
    >
      <IconButton onClick={onClick}>
        <XIcon sx={{ color: "shades.neutral.500", fontSize: "16px" }} />
      </IconButton>
    </Row>
  );
};

const Container = styled(Row)(({ theme }) => ({
  width: "100%",
  color: theme.palette.shades.neutral[800],
  justifyContent: "space-between",
  paddingBottom: theme.spacing(1),
}));

const Content = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

const PaymentMethodDetails = ({ paymentMethod, onRemove }: CardItemProps) => {
  return (
    <Container>
      <Content>
        <Row spacing={1} variant="left">
          <Typography variant="bodyPrimaryReg">
            {getPaymentMethodDescription(paymentMethod)}
          </Typography>
          <Chip color="shades.neutral.500" bgcolor="shades.neutral.100">
            Default
          </Chip>
        </Row>
        {isCard(paymentMethod) && (
          <Typography>
            Expires {paymentMethod.card.expMonth}/{paymentMethod.card.expYear}
          </Typography>
        )}
        <CloseButton onClick={onRemove} />
      </Content>
      <CloseButton sm onClick={onRemove} />
    </Container>
  );
};

export default PaymentMethodDetails;
